import React, { useState } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Modal, IconButton } from 'shared-components';
// Import Global Components
import { isHRB, isMoniecorp, isOxford, getCardholderSupportEmail } from 'shared-components/src/utils/whitelabel';
import Route from '../components/Route';
// Import Layouts
import NotFound from '../layouts/NotFound';
import Private from './Private';
// Import Local Components
import Header from './Auth/components/Header';
import Login from './Auth/routes/Login';
import Activate from './Auth/routes/Activate';
import Alert from '../components/Alert';
// import Register from "./layouts/Register";
import Register from './Auth/routes/Register';
import ForgotPassword from './Auth/routes/ForgotPassword';
import ResetPassword from './Auth/routes/ResetPassword';
import CardProxyPage from './Auth/routes/CardholderAgreement';
// Import Layouts
import Body from '../layouts/Body';
import Shell from '../layouts/Shell';
import Footer from '../layouts/Footer';
import { Base } from './Auth/styles';
// Import redirect device component
import RedirectToDevicePortal from './RedirectToDevicePortal';
import Balance from './Auth/routes/Balance';
import ZohoDeskASAP from '../components/ZohoDeskASAP';

export default props => {
  const isHRBClient = isHRB();
  const isMonieCorpClient = isMoniecorp();
  const intl = useIntl();
  const [e6DetailedMigrationModal, setE6DetailedMigrationModal] = useState(false);

  const shouldShowSupportChatbot = () => {
    if (isOxford()) {
      return false;
    }
    
    return true;
  };

  // eslint-disable-next-line react/destructuring-assignment, react/prop-types
  const callCenterBanner = props && props.callCenterBanner;
  // eslint-disable-next-line react/destructuring-assignment, react/prop-types
  const e6MigrationBanner = props && props.e6MigrationBanner;

  const handleClick = () => {
    setE6DetailedMigrationModal(true);
  };

  return (
    <Shell>
      <Switch>
        {isMonieCorpClient && (
          <Route
            exact
            path="/"
            render={() => <Redirect to="/checkcardbalance" />}
          />
        )}
        <Route
          exact
          path="/cardholder-agreement"
          render={routeProps => {
            return (
              <Base>
                <Header {...routeProps} {...props} />
                <Body>
                  <CardProxyPage {...routeProps} />
                  <Footer />
                </Body>
              </Base>
            );
          }}
        />
        <Route
          exact
          path="/login"
          render={routeProps => {
            return (
              <Base>
                <Header {...routeProps} {...props} />
                <Body>
                  { 
                    e6MigrationBanner && (
                      <Alert
                        // eslint-disable-next-line dot-notation
                        alert={intl.messages['e6-migration-banner-short-alert']}
                        type='warn'
                        alertFor='e6-migration-banner-short'
                        style={{
                          display: 'inline',
                        }}
                        values={{
                          a: chunks => (
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                handleClick();
                              }}
                              style={{
                                textDecoration: 'underline',
                                color: 'inherit',
                              }}
                            >
                              {chunks}
                            </button>
                          ),
                          strong: chunks => (
                            <strong>
                              {chunks}
                            </strong>
                          )
                        }}
                      />
                    )
                  }
                  { 
                    callCenterBanner && (
                      <Alert
                        // eslint-disable-next-line dot-notation
                        alert={intl.messages['cardholder_support_email']}
                        type='warn'
                        alertFor='call-center-banner'
                        values={{
                          cardholder_support_email: getCardholderSupportEmail()
                        }}
                      />
                    ) 
                  }
                  { 
                    e6DetailedMigrationModal && (
                      <Modal>
                        <IconButton
                          iconType='x'
                          onClick={()=> setE6DetailedMigrationModal(false)}
                          style={{
                            position: 'absolute',
                            top: '30px',
                            right: '30px'
                          }}
                        />
                        <div style={{ padding: '20px', maxWidth: '600px' }}>
                          <h2>{intl.messages['maintenance-notification-header']}</h2>
                          <br />
                          <p>{intl.messages['maintenance-notification-greeting']}</p>
                          <br />
                          <p>
                            {intl.messages['maintenance-notification-body1-1']} <strong>{intl.messages['maintenance-notification-body1-2']}</strong> {intl.messages['maintenance-notification-body1-3']} 
                            <strong> {intl.messages['maintenance-notification-body1-4']}</strong>. {intl.messages['maintenance-notification-body1-5']} 
                            <strong> {intl.messages['maintenance-notification-body1-6']}</strong> ({intl.messages['maintenance-notification-body1-7']} <strong>{intl.messages['maintenance-notification-body1-8']}</strong>).
                          </p>
                          <br />
                          <h3>{intl.messages['impact-on-services']}</h3>
                          <p>{intl.messages['maintenance-notification-body2-1']} <strong>{intl.messages['maintenance-notification-body2-2']}</strong> {intl.messages['maintenance-notification-body2-3']}</p>
                          <br />
                          <ul style={{ listStyleType: 'disc', margin: '0' }}>
                            <li>{intl.messages['maintenance-impact-item1']}</li>
                            <li>{intl.messages['maintenance-impact-item2']}</li>
                            <li>{intl.messages['maintenance-impact-item3']}</li>
                            <li>{intl.messages['maintenance-impact-item4']}</li>
                          </ul>
                          <br />
                          <p>
                            {intl.messages['maintenance-notification-body3-1']} <strong>{intl.messages['maintenance-notification-body3-2']}</strong>, {intl.messages['maintenance-notification-body3-3']} <strong>{intl.messages['maintenance-notification-body3-4']}</strong>.
                          </p>
                          <br />
                          <p>
                            {intl.messages['apology-message']}
                          </p>
                          <br />
                          <p><strong>{intl.messages['thank-you-message']}</strong></p>
                        </div>
                      </Modal>
                    ) 
                  }
                  <Login {...routeProps} />
                  <Footer />
                </Body>
              </Base>
            );
          }}
        />
        <Route
          exact
          path="/activate"
          render={routeProps => {
            return (
              <Base>
                <Header {...routeProps} {...props} />
                <Body>
                  <Activate {...routeProps} />
                  <Footer />
                </Body>
              </Base>
            );
          }}
        />
        <Route
          exact
          path="/checkcardbalance"
          render={routeProps => {
            return (
              <Base>
                <Header {...routeProps} {...props} />
                <Body>
                  <Balance {...routeProps} />
                  <Footer />
                </Body>
              </Base>
            );
          }}
        />
        <Route
          exact
          path="/register"
          render={routeProps => {
            return (
              <Base>
                <Header {...routeProps} {...props} />
                <Body>
                  <Register {...routeProps} />
                  <Footer />
                </Body>
              </Base>
            );
          }}
        />
        <Route
          exact
          path="/forgot-password"
          render={routeProps => {
            return (
              <Base>
                <Header {...routeProps} {...props} />
                <Body>
                  <ForgotPassword {...routeProps} />
                  <Footer />
                </Body>
              </Base>
            );
          }}
        />
        <Route
          exact
          path="/reset-password"
          render={routeProps => {
            return (
              <Base>
                <Header {...routeProps} {...props} />
                <Body>
                  <ResetPassword {...routeProps} />
                  <Footer />
                </Body>
              </Base>
            );
          }}
        />
        {
          isHRBClient && (
            <Route
              exact
              path="/redirect-to-device-portal"
              render={routeProps => {
                return (
                  <Base>
                    <Header {...routeProps} {...props} />
                    <Body>
                      <RedirectToDevicePortal {...routeProps} />
                      <Footer />
                    </Body>
                  </Base>
                );
              }}
            />
          )
        }
        <Route
          priv
          render={routeProps => {
            return <Private {...routeProps} {...props} />;
          }}
        />
        <Route component={NotFound} />
      </Switch>
      {/* Zoho asapApp */}
      {shouldShowSupportChatbot() && <ZohoDeskASAP isHRBClient={isHRBClient} />}
    </Shell>
  );
};
